import { Component } from "react";
import axios from "./api.service";

export default class LevelService extends Component {
	static async createLevel(level) {
		return axios.post(`/level/create`, level);
	}

	static async listAllLevels() {
		return axios
			.get(`/level/getAll`)
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return [];
			});
	}

	static async listOneLevel(id) {
		return axios
			.get(`/level/getOne/${id}`)
			.then((res) => res.data.level)
			.catch((err) => console.error);
	}

	static async updateLevel(id, level) {
		return axios
			.put(`/level/edit/${id}`, level)
			.then((res) => console.log)
			.catch((err) => console.error);
	}

	static async deleteLevel(id) {
		return axios.delete(`/level/delete/${id}`);
	}
}
